
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
   
    listKullaniciFormSaved(id){
       return $axios.get('FormSaved/listKullaniciFormSaved/'+id);
    }

    //   delete(birim) {
    //     return $axios.delete('/Birim/delete/'+birim.id);
  
    //   }
  };